export const bookingCommissionColumn = [
    {
        Header: 'Booking Id',
        accessor: 'bookingId',
    },
    {
        Header: 'Bookingtype Name',
        accessor: 'bookingtypeName',
    },
    {
        Header: 'Bookingtype Soruce',
        accessor: 'bookingtypeSoruce',
    },
    {
        Header: 'Commission Rate',
        accessor: 'commissionRate',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const bookingCommissionTableData = [
    {
        "bookingId": "1101",
        "bookingtypeName": "Wedding",
        "bookingtypeSoruce":"Online",
        "commissionRate":"15%"
    },
    {
        "bookingId": "1102",
        "bookingtypeName": "Business Seminar",
        "bookingtypeSoruce":"Viaan",
        "commissionRate":"15%"
    },
    {
        "bookingId": "1103",
        "bookingtypeName": "Instant",
        "bookingtypeSoruce":"Jack",
        "commissionRate":"5%"
    },
    {
        "bookingId": "1104",
        "bookingtypeName": "Groups",
        "bookingtypeSoruce":"Tom",
        "commissionRate":"10%"
    },
    {
        "bookingId": "1105",
        "bookingtypeName": "Allocation",
        "bookingtypeSoruce":"Jerry",
        "commissionRate":"3%"
    },
    {
        "bookingId": "1106",
        "bookingtypeName": "Conference",
        "bookingtypeSoruce":"Online",
        "commissionRate":"8%"
    },
    {
        "bookingId": "1107",
        "bookingtypeName": "Corporate Retreat",
        "bookingtypeSoruce":"Viaan",
        "commissionRate":"12%"
    },
    {
        "bookingId": "1108",
        "bookingtypeName": "Group Travel",
        "bookingtypeSoruce":"Jack",
        "commissionRate":"7%"
    },
    {
        "bookingId": "1109",
        "bookingtypeName": "Package Booking",
        "bookingtypeSoruce":"Tom",
        "commissionRate":"10%"
    },
    {
        "bookingId": "1109",
        "bookingtypeName": "Special Event",
        "bookingtypeSoruce":"Jerry",
        "commissionRate":"5%"
    },
]